// components/SessionTimeoutWarning.js
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function SessionTimeoutWarning() {
  const { showTimeoutWarning, setShowTimeoutWarning, resetInactivityTimer, logout } = useAuth();

  if (!showTimeoutWarning) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 300,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24
    }}>
      <div style={{
        background: 'var(--bg-secondary)', border: '1px solid var(--border-accent)',
        borderRadius: 'var(--radius-xl)', padding: 28, maxWidth: 360, width: '100%',
        textAlign: 'center', animation: 'slideUp 0.2s ease'
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>⏱</div>
        <h3 style={{ marginBottom: 8 }}>Session Expiring</h3>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 24, fontSize: '0.9375rem' }}>
          Your session will expire in 2 minutes due to inactivity. Tap to continue.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn btn-secondary btn-full" onClick={() => logout()}>Sign Out</button>
          <button className="btn btn-primary btn-full" onClick={() => { resetInactivityTimer(); setShowTimeoutWarning(false); }}>
            Stay Signed In
          </button>
        </div>
      </div>
    </div>
  );
}
